export const employee = [
  {
    _id: "012",
    name: "Jenny Wilson",
    studentId: "ELRN-254264",
    course: "3D Character Creation",
    enrolledDate: "June 01, 2022",
    status: "complete",
    number: "5412458745",
    email: "suraj@gmail.com",
    gender: "Male",
    created: "20-02-2025, 06:00PM",
    isActive: true,
    aasign: "Employee 1",
    statusName: "New",
    price: "₹ 7,000",
    hospitalName: "Yashoda Hospitals",
  },
  {
    _id: "012",

    name: "Jeevan",
    studentId: "ELRN-254265",
    course: "3D Character Creation",
    enrolledDate: "June 01, 2025",
    status: "closed",
    number: "5412458745",
    email: "suraj@gmail.com",
    gender: "Male",
    created: "20-02-2025, 06:00PM",
    isActive: true,
    aasign: "Employee 1",
    statusName: "Progress",
    price: "₹ 7,000",
    hospitalName: "Yashoda Hospitals",
  },
  {
    _id: "012",

    name: "vishnu",
    studentId: "ELRN-254268",
    course: "3D Character Creation",
    enrolledDate: "June 05, 2025",
    status: "running",
    number: "5412458745",
    email: "suraj@gmail.com",
    gender: "Male",
    created: "20-02-2025, 06:00PM",
    isActive: true,
    aasign: "Employee 1",
    statusName: "Assigned",
    price: "₹ 7,000",
    hospitalName: "Yashoda Hospitals",
  },
  {
    _id: "012",

    name: " Wilson",
    studentId: "ELRN-254264",
    course: "3D Character Creation",
    enrolledDate: "June 01, 2022",
    status: "complete",
    email: "suraj@gmail.com",
    gender: "Male",
    aasign: "Employee 1",
    number: "5412458745",
    created: "20-02-2025, 06:00PM",
    isActive: true,
    statusName: "Resolved",
    price: "₹ 7,000",
    hospitalName: "Yashoda Hospitals",
  },
];
